import { isCompleteAsset, normalizeAsset } from './search.js';

const STORAGE_KEY = 'arz.converter.preferences.v1';
const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

function storage() {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
}

function validSlug(value) {
  return typeof value === 'string' && value.length <= 100 && SLUG_PATTERN.test(value);
}

function readPreferences() {
  const deviceStorage = storage();
  if (!deviceStorage) return null;
  try {
    const value = JSON.parse(deviceStorage.getItem(STORAGE_KEY) || 'null');
    const baseAmount = Number(value?.baseAmount);
    if (!validSlug(value?.baseSlug) || !validSlug(value?.quoteSlug)
      || value.baseSlug === value.quoteSlug || !Number.isFinite(baseAmount) || baseAmount < 0) return null;
    return { baseSlug: value.baseSlug, quoteSlug: value.quoteSlug, baseAmount };
  } catch (error) {
    return null;
  }
}

export function persistPreferences(state) {
  if (!state.rememberPreferences) return;
  const deviceStorage = storage();
  if (!deviceStorage) return;
  const baseAmount = Number(state.baseAmount);
  if (!validSlug(state.base?.slug) || !validSlug(state.quote?.slug)
    || state.base.slug === state.quote.slug || !Number.isFinite(baseAmount) || baseAmount < 0) return;
  try {
    deviceStorage.setItem(STORAGE_KEY, JSON.stringify({
      baseSlug: state.base.slug,
      quoteSlug: state.quote.slug,
      baseAmount,
    }));
  } catch (error) {
    // Storage can be unavailable in private or restricted browser contexts.
  }
}

async function loadAsset(state, slug) {
  const base = state.root.dataset.converterNexus || window.arzConstants?.NEXUS_BASEURL || '';
  if (!base) return null;
  const response = await fetch(`${base.replace(/\/$/, '')}/v1/pub/coins/${encodeURIComponent(slug)}`, {
    credentials: 'omit',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) return null;
  const payload = await response.json();
  const asset = normalizeAsset(payload?.data, payload?.data?.type || 'all');
  return isCompleteAsset(asset) ? asset : null;
}

export async function restorePreferences(state) {
  if (!state.rememberPreferences) return null;
  const saved = readPreferences();
  if (!saved) return null;
  try {
    const [base, quote] = await Promise.all([
      loadAsset(state, saved.baseSlug),
      loadAsset(state, saved.quoteSlug),
    ]);
    if (!base || !quote || base.slug === quote.slug) return null;
    return { base, quote, baseAmount: saved.baseAmount };
  } catch (error) {
    return null;
  }
}
